import { useDispatch } from "react-redux";

import { PAGE_VIEWED, TRACK_CONTENT_HUB_ADD_COVER_IMAGE_CLICKED_EVENT, TRACK_CONTENT_SECTION_MOVED, TRACK_CONTENT_HUB_COVER_IMAGE_ADDED, TRACK_CONTENT_HUB_CREATE_STREAM_CLICKED_EVENT, TRACK_CONTENT_HUB_DELETE_SECTION_CLICKED, TRACK_CONTENT_HUB_EDIT_HUB_CLICKED_EVENT, TRACK_CONTENT_HUB_EDIT_SCREEN_VIEW, TRACK_CONTENT_HUB_MANAGE_CONTENT_CLICKED, TRACK_CONTENT_HUB_SCREEN_VIEW, TRACK_CONTENT_HUB_SECTION_CONTENT_CREATE_SELECTION_TYPE_CONFIRMATION_SCREEN_VIEW, TRACK_CONTENT_HUB_SECTION_CONTENT_SELECT_CLICKED, TRACK_CONTENT_HUB_SECTION_DELETE_CONFIRMATION_SCREEN_VIEW, TRACK_CONTENT_HUB_SECTION_SAVE_CLICKED, TRACK_CONTENT_HUB_SECTION_SAVE_CONFIRM_CLICKED, TRACK_CONTENT_HUB_SWITCH_SCREEN_VIEW, TRACK_SECTION_CREATE_LAYOUT_SCREEN_VIEW, TRACK_STREAM_CREATE_SCREEN_VIEW, TRACK_SECTION_CREATE_CONTENT_SCREEN_VIEW, TRACK_NOTIFICATIONS_LIST_SCREEN_VIEW, TRACK_COLLECTION_VIEWED_EVENT, TRACK_CONTENT_HUB_CREATE_NEW_SECTION_CLICKED, TRACK_CONTENT_HUB_STREAM_CONTENT_LAYOUT_SELECTED_EVENT, TRACK_CONTENT_HUB_SECTION_CONTENT_SELECTION_TYPE_SELECTED_EVENT, TRACK_CONTENT_HUB_SECTION_CONTENT_SELECTION_TYPE_CONFIRMED, TRACK_CONTENT_HUB_SECTION_MANAGE_CONTENT_CLICKED, TRACK_CONTENT_HUB_SECTION_CONTENT_ADDED_EVENT, TRACK_CONTENT_HUB_SECTION_CONTENT_REMOVED_EVENT, TRACK_CONTENT_HUB_SECTION_CONTENT_SELECTION_SAVED, TRACK_CONTENT_HUB_SECTION_EDITED, TRACK_CONTENT_HUB_SECTION_CREATED, TRACK_CONTENT_HUB_SECTION_DELETED_CLICKED, TRACK_CONTENT_HUB_EDITED_EVENT, TRACK_CONTENT_HUB_SWITCH_CLICKED, TRACK_CONTENT_HUB_SWITCHED, TRACK_CONTENT_HUB_CLONE_HUB_CLICKED_EVENT, TRACK_CONTENT_HUB_CLONED_EVENT, TRACK_CONTENT_HUB_CREATE_ASSET_CLICKED, TRACK_CONTENT_HUB_ASSET_TYPE_SELECTED, TRACK_CONTENT_HUB_ASSET_CREATED_EVENT, TRACK_CHROME_EXTENSION_DOWNLOAD_CLICKED_EVENT } from "src/constants/adoption/eventTypes";
import { trackEventForAdoption } from "../adoption";

import _ from "lodash";
import { CreateAssetFileType, ISectionDirection } from "src/types/hub";
import { ContentSelectionType, EntityType, IAssetCreated, ILayoutType, ISectionUpdate } from "src/types/adoption/hub";

export const useHubAdoption = () => {

  const dispatch = useDispatch();

  const dispatchEvent = (data: any) => {
    dispatch(trackEventForAdoption(data));
  }

  const trackScreenView = (screenName: string) => {
    const data = {
      event: PAGE_VIEWED,
      properties: { screen_name: screenName }
    }
    dispatchEvent(data);
  }

  const trackHubScreenView = () => trackScreenView(TRACK_CONTENT_HUB_SCREEN_VIEW);
  const trackCreateStreamScreenView = () => trackScreenView(TRACK_STREAM_CREATE_SCREEN_VIEW);
  const trackHubSwitchScreenView = () => trackScreenView(TRACK_CONTENT_HUB_SWITCH_SCREEN_VIEW);
  const trackHubEditScreenView = () => trackScreenView(TRACK_CONTENT_HUB_EDIT_SCREEN_VIEW);
  const trackSectionCreateLayoutScreenView = () => trackScreenView(TRACK_SECTION_CREATE_LAYOUT_SCREEN_VIEW);
  const trackSectionCreateContentScreenView = () => trackScreenView(TRACK_SECTION_CREATE_CONTENT_SCREEN_VIEW);
  const trackNotificationListScreenView = () => trackScreenView(TRACK_NOTIFICATIONS_LIST_SCREEN_VIEW);

  const trackCollectionViewedEvent = (collectionName: string) => {
    const data = {
      event: TRACK_COLLECTION_VIEWED_EVENT,
      properties: {
        collection_name: collectionName
      }
    }

    dispatchEvent(data);
  }

  const trackHubSectionDeleteConfirmationScreenView = () => {

    const data = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_CONTENT_HUB_SECTION_DELETE_CONFIRMATION_SCREEN_VIEW
      }
    }

    dispatchEvent(data);

  }

  const trackSmartFilterConfirmationScreenView = () => {

    const data = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_CONTENT_HUB_SECTION_CONTENT_CREATE_SELECTION_TYPE_CONFIRMATION_SCREEN_VIEW
      }
    }

    dispatchEvent(data);

  }

  const trackHubCreateStreamClickedEvent = () => {

    const data = {
      event: TRACK_CONTENT_HUB_CREATE_STREAM_CLICKED_EVENT,
      properties: {}
    }

    dispatchEvent(data);
  }

  const trackHubAddCoverImageClickedEvent = () => {

    let data = {
      event: TRACK_CONTENT_HUB_ADD_COVER_IMAGE_CLICKED_EVENT,
      properties: {}
    }

    dispatchEvent(data);

  }

  const trackHubCoverImageAddedEvent = () => {

    let data = {
      event: TRACK_CONTENT_HUB_COVER_IMAGE_ADDED,
      properties: {}
    }

    dispatchEvent(data);
  }


  const trackEditHubClickedEvent = () => {

    let data = {
      event: TRACK_CONTENT_HUB_EDIT_HUB_CLICKED_EVENT,
      properties: {}
    }

    dispatchEvent(data);

  }

  const trackHubManageContentClickedEvent = () => {

    let data = {
      event: TRACK_CONTENT_HUB_MANAGE_CONTENT_CLICKED,
      properties: {}
    }

    dispatchEvent(data);

  }

  const trackHubCreateSectionClicked = () => {

    let data = {
      event: TRACK_CONTENT_HUB_CREATE_NEW_SECTION_CLICKED,
      properties: {}
    }

    dispatchEvent(data);
  }

  const trackHubSectionContentLayoutSelectedEvent = ({ layoutType, layoutPalette }: ILayoutType) => {

    let properties = {
      layout_type: layoutType,
      layout_palette: layoutPalette,
    }

    let data = {
      event: TRACK_CONTENT_HUB_STREAM_CONTENT_LAYOUT_SELECTED_EVENT,
      properties: properties
    }

    dispatchEvent(data);
  }


  const trackHubSectionContentSelectionTypeSelectedEvent = (selectionType: ContentSelectionType) => {

    let properties = {
      selection_type: selectionType
    }

    let data = {
      event: TRACK_CONTENT_HUB_SECTION_CONTENT_SELECTION_TYPE_SELECTED_EVENT,
      properties: properties
    }

    dispatchEvent(data);

  }

  const trackHubSectionContentSelectionTypeConfirmEvent = (selectionType: ContentSelectionType) => {

    let properties = {
      selection_type: selectionType
    }

    let data = {
      event: TRACK_CONTENT_HUB_SECTION_CONTENT_SELECTION_TYPE_CONFIRMED,
      properties: properties
    }

    dispatchEvent(data);

  }


  const trackHubSectionContentSelectClicked = () => {
    let data = {
      event: TRACK_CONTENT_HUB_SECTION_CONTENT_SELECT_CLICKED,
      properties: {}
    }

    dispatchEvent(data)
  }

  const trackHubSectionManageContentClicked = () => {

    let data = {
      event: TRACK_CONTENT_HUB_SECTION_MANAGE_CONTENT_CLICKED,
      properties: {}
    }

    dispatchEvent(data);
  }

  const trackDeleteSectionClickedEvent = () => {

    let data = {
      event: TRACK_CONTENT_HUB_DELETE_SECTION_CLICKED,
      properties: {}
    }

    dispatchEvent(data)

  }

  const trackSectionMovedEvent = (direction: ISectionDirection) => {

    const properties = {
      direction: direction
    }

    let data = {
      event: TRACK_CONTENT_SECTION_MOVED,
      properties: properties
    }

    dispatchEvent(data);
  }

  const trackSectionSaveClickedEvent = ({ layoutType, layoutPalette }: ILayoutType) => {

    let properties = {
      layout_type: layoutType,
      layout_palette: layoutPalette,
    }

    let data = {
      event: TRACK_CONTENT_HUB_SECTION_SAVE_CLICKED,
      properties: properties
    }

    dispatchEvent(data);
  }

  const trackSectionSaveConfirmClickedEvent = ({ layoutType, layoutPalette }: ILayoutType) => {

    let properties = {
      layout_type: layoutType,
      layout_palette: layoutPalette,
    }

    let data = {
      event: TRACK_CONTENT_HUB_SECTION_SAVE_CONFIRM_CLICKED,
      properties: properties
    }

    dispatchEvent(data);

  }

  const trackSectionEditedEvent = (properties: ISectionUpdate) => {

    let data = {
      event: TRACK_CONTENT_HUB_SECTION_EDITED,
      properties: properties
    }

    dispatchEvent(data);
  }

  const trackSectionCreatedEvent = (properties: ISectionUpdate) => {

    let data = {
      event: TRACK_CONTENT_HUB_SECTION_CREATED,
      properties: properties
    }

    dispatchEvent(data);
  }

  const trackSectionContentAddedEvent = (contentType: EntityType) => {

    let properties = {
      content_type: contentType
    }

    let data = {
      event: TRACK_CONTENT_HUB_SECTION_CONTENT_ADDED_EVENT,
      properties: properties
    }

    dispatchEvent(data)

  }

  const trackSectionContentRemovedEvent = (contentType: EntityType) => {

    let properties = {
      content_type: contentType
    }

    let data = {
      event: TRACK_CONTENT_HUB_SECTION_CONTENT_REMOVED_EVENT,
      properties: properties
    }

    dispatchEvent(data)

  }

  const trackSectionDeletedEvent = () => {

    let data = {
      event: TRACK_CONTENT_HUB_SECTION_DELETED_CLICKED,
      properties: {}
    }

    dispatchEvent(data)
  }
  

  const trackContentHubEditedEvent = (layoutName: string) => {
    const data = {
      event: TRACK_CONTENT_HUB_EDITED_EVENT,
      properties: {
        layout_name: layoutName
      }
    }
    dispatchEvent(data)
  }

  
  const trackHubSwitchClickedEvent = () => {

    let data = {
      event: TRACK_CONTENT_HUB_SWITCH_CLICKED,
      properties: {}
    }

    dispatchEvent(data)

  }

  const trackHubSwitchedEvent = (layoutName: string) => {
    const data = {
      event: TRACK_CONTENT_HUB_SWITCHED,
      properties: {
        layout_name: layoutName
      }
    }
    dispatchEvent(data)
  }

  const trackCloneHubClickedEvent = () => {
    const data = {
      event: TRACK_CONTENT_HUB_CLONE_HUB_CLICKED_EVENT,
      properties: {}
    }
    dispatchEvent(data)
  }

  

  const trackHubClonedEvent = (layoutName: string) => {
    const data = {
      event: TRACK_CONTENT_HUB_CLONED_EVENT,
      properties: {
        layout_name: layoutName
      }
    }
    dispatchEvent(data)
  }

  

  const trackCreateAssetClickedEvent = () => {
    const data = {
      event: TRACK_CONTENT_HUB_CREATE_ASSET_CLICKED,
      properties: {}
    }
    dispatchEvent(data)
  }


  const trackAssetTypeSelected = (type : CreateAssetFileType) => {
    const data = {
      event: TRACK_CONTENT_HUB_ASSET_TYPE_SELECTED,
      properties: { 
        asset_type: type
       }
    }
    dispatchEvent(data)
  }

  const trackAssetCreatedEvent = (properties : IAssetCreated) => {

    const data = {
      event: TRACK_CONTENT_HUB_ASSET_CREATED_EVENT,
      properties: properties
    }

    dispatchEvent(data)

  }

  const trackSectionContentSelectionSavedEvent = (contentType: EntityType) => {

    let properties = {
      content_type: contentType
    }

    let data = {
      event: TRACK_CONTENT_HUB_SECTION_CONTENT_SELECTION_SAVED,
      properties: properties
    }

    dispatchEvent(data)

  }

  const trackChromeExtensionDownloadClickedEvent = () => {

    let data = {
      event: TRACK_CHROME_EXTENSION_DOWNLOAD_CLICKED_EVENT,
      properties: {}
    }

    dispatchEvent(data);
  }

  return {
    trackHubScreenView,
    trackCreateStreamScreenView,
    trackHubSwitchScreenView,
    trackHubEditScreenView,
    trackSectionCreateLayoutScreenView,
    trackSectionCreateContentScreenView,
    trackNotificationListScreenView,
    trackCollectionViewedEvent,
    trackHubSectionDeleteConfirmationScreenView,
    trackSmartFilterConfirmationScreenView,
    trackHubCreateStreamClickedEvent,
    trackHubAddCoverImageClickedEvent,
    trackHubCoverImageAddedEvent,
    trackEditHubClickedEvent,
    trackHubManageContentClickedEvent,
    trackHubCreateSectionClicked,
    trackHubSectionContentLayoutSelectedEvent,
    trackHubSectionContentSelectionTypeSelectedEvent,
    trackHubSectionContentSelectionTypeConfirmEvent,
    trackHubSectionContentSelectClicked,
    trackHubSectionManageContentClicked,
    trackSectionContentAddedEvent,
    trackSectionContentRemovedEvent,
    trackSectionContentSelectionSavedEvent,
    trackSectionEditedEvent,
    trackSectionCreatedEvent,
    trackDeleteSectionClickedEvent,
    trackSectionDeletedEvent,
    trackContentHubEditedEvent,
    trackHubSwitchClickedEvent,
    trackHubSwitchedEvent,
    trackCloneHubClickedEvent,
    trackHubClonedEvent,
    trackCreateAssetClickedEvent,
    trackAssetTypeSelected, 
    trackAssetCreatedEvent,

    trackSectionMovedEvent,
    trackSectionSaveClickedEvent,
    trackSectionSaveConfirmClickedEvent,

    trackChromeExtensionDownloadClickedEvent
  }

}